import { createAction, props } from '@ngrx/store';

import { SortDirection } from '../constants';
import { PropertyViewConfig } from '../services/feed-settings.service';

export const setHomeFilterString = createAction(
  '[Home] Set Home Filter String',
  props<{ filterString: string }>(),
);

export const setHomeSortingField = createAction(
  '[Home] Set Home Sorting Field',
  props<{ sortingField: string }>(),
);

export const setHomeSortingDirection = createAction(
  '[Home] Set Home Sorting Direction',
  props<{ sortingDirection: SortDirection }>(),
);

export const setHomeTab = createAction(
  '[Home] Set Home Tab',
  props<{ tab: 'recent' | 'active' | 'archived' | 'deleted' }>(),
);

export const setHomeObjectsLifeCycle = createAction(
  '[Home] Set Home Objects Lifecycle',
  props<{ homeObjectsLifeCycle: number }>(),
);

export const fetchHomeViewConfig = createAction(
  '[Home] Fetch Home View Config',
  props<{ userId: string }>(),
);

export const fetchHomeViewConfigSuccess = createAction(
  '[Home] Fetch Home View Config Success',
  props<{
    defaultHomeConfig: PropertyViewConfig[];
    homeConfig: PropertyViewConfig[];
  }>(),
);

export const fetchHomeViewConfigFail = createAction(
  '[Home] Fetch Home View Config Fail',
  props<{ error: string }>(),
);

export const toggleHomeViewConfigOption = createAction(
  '[Home] Toggle Home View Config Option',
  props<{ optionName: string }>(),
);

export const toggleHomeViewConfigOptionSuccess = createAction(
  '[Home] Toggle Home View Config Option Success',
);

export const toggleHomeViewConfigOptionFail = createAction(
  '[Home] Toggle Home View Config Option Fail',
  props<{ error: string }>(),
);
